var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsHeartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_98_16404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0485 21.9256C13.6179 22.3321 14.3821 22.3321 14.9515 21.9256C17.7975 19.894 20.5229 17.5566 22.4081 14.5655C23.3526 13.067 23.7485 11.8552 23.9043 10.8642C23.9671 10.5153 24 10.1553 24 9.78735C24 6.59109 21.5194 4 18.4595 4C16.6308 4 15.0091 4.92537 14 6.35227C12.9909 4.92537 11.3692 4 9.54054 4C6.48058 4 4 6.59109 4 9.78735C4 10.1553 4.03288 10.5153 4.09574 10.8642C4.25146 11.8552 4.64736 13.067 5.59186 14.5655C7.47715 17.5566 10.2025 19.894 13.0485 21.9256Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0485 19.493C13.6179 19.8995 14.3821 19.8995 14.9515 19.493C18.0845 17.8028 19.2113 17.2394 22.4081 14.5655C23.3526 13.067 23.7485 11.8552 23.9043 10.8642C23.9671 10.5153 24 10.1553 24 9.78735C24 6.59109 21.5194 4 18.4595 4C16.6308 4 15.0091 4.92537 14 6.35227C12.9909 4.92537 11.3692 4 9.54054 4C6.48058 4 4 6.59109 4 9.78735C4 10.1553 4.03288 10.5153 4.09574 10.8642C4.25146 11.8552 4.64736 13.067 5.59186 14.5655C9.07042 17.2394 10.1972 17.8028 13.0485 19.493Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_98_16404",
    x: 0,
    y: 0.33,
    width: 28,
    height: 26.2305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.33
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_98_16404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_98_16404",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsHeartIcon);
export default __webpack_public_path__ + "static/media/es_heart_icon.dd2900375f9a44e898daa525c75dbf2a.svg";
export { ForwardRef as ReactComponent };